import {ReactNode, useState} from "react";
import {RightOutlined} from "@ant-design/icons";
import "./collapsable-box.css";

interface CollapsableBoxProps {
    title: string;
    onOpen?: () => void;
    onClose?: () => void;
    children: ReactNode | ReactNode[];
    isInitiallyOpen?: boolean;
    actions?: ReactNode | ReactNode[];
    shortStatus?: ReactNode | ReactNode[];
}

const CollapsableBox = ({
    title,
    onOpen,
    onClose,
    children,
    isInitiallyOpen = false,
    actions = null,
    shortStatus = null
}: CollapsableBoxProps) => {

    const [isOpen, setIsOpen] = useState(isInitiallyOpen);

    const toggle = () => {
        if(!isOpen && onOpen) {
            onOpen();
        } else if(isOpen && onClose) {
            onClose();
        }
        setIsOpen(!isOpen);
    }

    const shortStatusComponent = <div className="short-status">{shortStatus}</div>

    return (
        <div className={`collapsable-box-container ${isOpen ? 'open' : ''}`}>
            <div className="inner">
                <div className="head" onClick={toggle}>
                    <div className="left">
                        <div className="arrow"><RightOutlined size={12} /></div>
                        <div className="title">{title}</div>
                    </div>
                    <div className="right">
                        {isOpen ? actions ? <div className="actions-container">{actions}</div> : shortStatusComponent : shortStatusComponent}
                    </div>
                </div>
                <div className="content">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default CollapsableBox;